import { compose } from 'redux';
import { SubmissionError } from 'redux-form';

import transformErrors from 'ha/helpers/forms/transformErrors';
import { Thunk } from 'ha/myredux/types';
import { send as showAlert } from 'ha/modules/Alertbar/actions';
import { PayReqWithConversationParams } from 'ha/services/osiris';
import { AlertType } from 'ha/modules/Alertbar/types';
import isEmpty from 'ha/utils/isEmpty';
import ApiError from 'ha/services/apiV2/errors/ApiError';

import { Messages } from '../constants';
import { FormData } from '../types';
import { Actions as PayReqActions } from './common';
import { closePaymentRequestModal } from './modal';
import { normalize } from '../helpers';

interface Errors {
  errors?: Array<{ key: string; detail: string }>;
}

const formErrors = compose(
  transformErrors,
  // TODO: update on PR #5398
  ({ errors }: Errors) => (Array.isArray(errors) ? errors : []),
  (e: ApiError) => (e.response as Errors) || {},
);

const successMsg = {
  text: Messages.payReqCreated,
  kind: AlertType.Success,
  dismissAfter: 5000,
};

const failMsg = {
  text: Messages.payReqFailure,
  kind: AlertType.Danger,
  dismissAfter: 5000,
};

const createPaymentRequest = (
  formData: FormData,
  conversation: PayReqWithConversationParams,
): Thunk => (dispatch, _, { osiris }) => {
  return osiris
    .addConversationPaymentRequest(normalize(formData, conversation))
    .then(({ data }) => {
      dispatch(showAlert(successMsg));
      dispatch(closePaymentRequestModal());
      dispatch(PayReqActions.created(data));
    })
    .catch((err: ApiError) => {
      const errors = formErrors(err);

      if (isEmpty(errors)) {
        dispatch(showAlert(failMsg));
      }

      return Promise.reject(new SubmissionError(errors));
    });
};

export default createPaymentRequest;
